

import React from "react";
import { Link } from "react-router-dom";
import { FaFacebookF, FaXTwitter, FaInstagram, FaYoutube } from "react-icons/fa6";

function Footer() {
  return (
    <footer
      style={{
        background: "linear-gradient(120deg, #ffe7ba, #ffd6b5, #ffccb5)", // 🌸 soft gold-peach-beige
        color: "#4b2e05",
        padding: "50px 0 25px",
        fontFamily: "'Poppins', sans-serif",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* ✨ Soft decorative glow circle */}
      <div
        style={{
          position: "absolute",
          top: "-100px",
          right: "-100px",
          width: "250px",
          height: "250px",
          background: "radial-gradient(circle, rgba(255,255,255,0.4), transparent)",
          borderRadius: "50%",
          zIndex: 0,
        }}
      ></div>

      <div className="container position-relative" style={{ zIndex: 1 }}>
        <div className="row text-start">
          {/* 🌸 Column 1 */}
          <div className="col-md-3 mb-4">
            <h5 style={{ fontWeight: "700", color: "#5a3a0e" }}>
              Bhaktamar Wale Baba
            </h5>
            <p style={{ marginTop: "10px", lineHeight: "1.7", color: "#6b4a2e" }}>
              For spiritual guidance and divine blessings.
            </p>
          </div>

          {/* 🌼 Column 2 - Quick Links */}
          <div className="col-md-3 mb-4">
            <h6
              style={{
                color: "#5a3a0e",
                fontWeight: "700",
                borderBottom: "2px solid #c97b2b",
                display: "inline-block",
                paddingBottom: "3px",
              }}
            >
              Quick Links
            </h6>
            <ul
              style={{
                listStyle: "none",
                marginTop: "15px",
                padding: "0",
                lineHeight: "2",
              }}
            >
              {[
                { path: "/", label: "Home" },
                { path: "/about", label: "About" },
                { path: "/verses", label: "Shlokas" },
                { path: "/healing", label: "Healing" },
                { path: "/resources", label: "Resources" },
                { path: "/achievements", label: "Achievements" },
                { path: "/contact", label: "Contact" },
              ].map((item, i) => (
                <li key={i}>
                  <Link
                    to={item.path}
                    style={{
                      color: "#4b2e05",
                      textDecoration: "none",
                      fontWeight: "500",
                      transition: "color 0.3s ease",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.color = "#c97b2b")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.color = "#4b2e05")
                    }
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* 🌻 Column 3 - Social Media */}
          <div className="col-md-3 mb-4">
            <h6
              style={{
                color: "#5a3a0e",
                fontWeight: "700",
                borderBottom: "2px solid #c97b2b",
                display: "inline-block",
                paddingBottom: "3px",
              }}
            >
              Connect With Us
            </h6>
            <div className="d-flex gap-3 mt-3">
              {[
                { icon: <FaFacebookF />, link: "https://facebook.com" },
                { icon: <FaXTwitter />, link: "https://twitter.com" },
                { icon: <FaInstagram />, link: "https://instagram.com" },
                { icon: <FaYoutube />, link: "https://youtube.com" },
              ].map((item, i) => (
                <a
                  key={i}
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: "#4b2e05",
                    background: "rgba(255, 255, 255, 0.5)",
                    padding: "10px",
                    borderRadius: "50%",
                    transition: "all 0.3s ease",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "#c97b2b";
                    e.currentTarget.style.color = "#fff";
                    e.currentTarget.style.transform = "scale(1.1)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "rgba(255,255,255,0.5)";
                    e.currentTarget.style.color = "#4b2e05";
                    e.currentTarget.style.transform = "scale(1)";
                  }}
                >
                  {item.icon}
                </a>
              ))}
            </div>
          </div>

          {/* 🌺 Column 4 - Contact Info */}
          <div className="col-md-3 mb-4">
            <h6
              style={{
                color: "#5a3a0e",
                fontWeight: "700",
                borderBottom: "2px solid #c97b2b",
                display: "inline-block",
                paddingBottom: "3px",
              }}
            >
              Contact Info
            </h6>
            <p style={{ marginTop: "10px", lineHeight: "1.8", color: "#6b4a2e" }}>
              Bhaktamar Kalash Tirth, Bhandgaon, Maharashtra 412203, India <br />
              <strong>Phone:</strong> +91 91555 99968 <br />
              <strong>Email:</strong>{" "}
              <a
                href="mailto:info@bhaktamarwalebaba.com"
                style={{
                  color: "#c97b2b",
                  textDecoration: "none",
                  fontWeight: "600",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.textDecoration = "underline")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.textDecoration = "none")
                }
              >
                info@bhaktamarwalebaba.com
              </a>
            </p>
          </div>
        </div>

        <hr style={{ borderColor: "rgba(0,0,0,0.2)" }} />
        <p
          className="text-center mb-0"
          style={{ fontSize: "14px", color: "#4b2e05" }}
        >
          © {new Date().getFullYear()} Bhaktamar Wale Baba. All Rights Reserved. {" "}
          <br />
          Designed and Developed by <strong>Khandelwal Digamber Jain Panchayat, Rajabazar, Chh. SambhajiNagar, Maharashtra</strong>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
